import { typeSafeTranslate } from '@bentley/pw-i18n';
import resources from '../../resources/languages.json';
export const t = typeSafeTranslate(resources);
